import { render, staticRenderFns } from "./TransferToAccount.vue?vue&type=template&id=12beccaa&scoped=true"
import script from "./TransferToAccount.vue?vue&type=script&lang=js"
export * from "./TransferToAccount.vue?vue&type=script&lang=js"
import style0 from "./TransferToAccount.vue?vue&type=style&index=0&id=12beccaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12beccaa",
  null
  
)

export default component.exports